import { useState } from 'react';
import { Modal, Form, Button } from 'react-bootstrap';
import { Pencil, Trash2 } from 'lucide-react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { FaSearch} from "react-icons/fa";

export default function AccountsType() {
  const [entriesList, setEntriesList] = useState([
    { identifier: 1, accountTypeName: 'efewf' },
    { identifier: 2, accountTypeName: 'efewf' },
    { identifier: 3, accountTypeName: 'efewf' },
    { identifier: 4, accountTypeName: 'ffff' },
    { identifier: 5, accountTypeName: 'gergregergf' },
    { identifier: 6, accountTypeName: 'test' },
  ]);

  const [dialogOpen, setDialogOpen] = useState(false);
  const [editingEntry, setEditingEntry] = useState(null);
  const [nameFieldValue, setNameFieldValue] = useState('');
  const [searchFilterText, setSearchFilterText] = useState('');

  const handleInitiateCreate = () => {
    setEditingEntry(null);
    setNameFieldValue('');
    setDialogOpen(true);
  };

  const handleInitiateEdit = (entry) => {
    setEditingEntry(entry);
    setNameFieldValue(entry.accountTypeName);
    setDialogOpen(true);
  };

  const handlePerformDelete = (identifier) => {
    setEntriesList(entriesList.filter(entry => entry.identifier !== identifier));
  };

  const handleConfirmSave = () => {
    if (editingEntry) {
      setEntriesList(entriesList.map(entry =>
        entry.identifier === editingEntry.identifier
          ? { ...entry, accountTypeName: nameFieldValue }
          : entry
      ));
    } else {
      const freshEntry = {
        identifier: Math.max(...entriesList.map(e => e.identifier), 0) + 1,
        accountTypeName: nameFieldValue,
      };
      setEntriesList([...entriesList, freshEntry]);
    }
    setDialogOpen(false);
  };

  const handlePerformExport = () => {
    console.log('Exporting account types:', entriesList);
  };

  const handleClearFilter = () => {
    setSearchFilterText('');
  };

  const filteredEntries = entriesList.filter(entry =>
    entry.accountTypeName.toLowerCase().includes(searchFilterText.toLowerCase())
  );

  return (
    <div className="atm-outer-wrapper" style={{ maxWidth: '1299px', margin: 'auto', padding: '20px' }}>
      <div className="atm-top-bar" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', backgroundColor: '#fff', padding: '14px 24px', borderRadius: '8px', boxShadow: '0 2px 8px rgba(0,0,0,0.1)', marginBottom: '20px' }}>
        <h5 className="atm-main-title" style={{ margin: 0, fontWeight: '600', fontSize: '20px', color: '#333' }}>Account Type</h5>
        <div className="atm-button-group" style={{ display: 'flex', gap: '12px' }}>
          <button className="atm-create-btn" onClick={handleInitiateCreate} style={{ backgroundColor: '#53b7e8', border: 'none', color: 'white', padding: '10px 16px', borderRadius: '6px', cursor: 'pointer', fontWeight: '500' }}>
            Create Account Type
          </button>
          <button className="atm-export-btn" onClick={handlePerformExport} style={{ backgroundColor: '#53b7e8', border: 'none', color: 'white', padding: '10px 16px', borderRadius: '6px', cursor: 'pointer', fontWeight: '500' }}>
            Export
          </button>
        </div>
      </div>

<div
  className="atm-search-bar"
  style={{
    marginTop:'-18px',
    marginLeft:'-12px',
    display: 'flex',
    alignItems: 'center',
    gap: '10px',            
    marginBottom: '16px',
    padding: '10px 14px',
    borderRadius: '8px',
  }}
>
  <div
    style={{
      position: 'relative',
      width: '230px',        
    }}
  >
    <FaSearch
      style={{
        position: 'absolute',
        left: '10px',
        top: '50%',
        transform: 'translateY(-50%)',
        color: '#bcbbbbff',
        fontSize: '13px',
      }}
    />

    <input
      type="text"
      placeholder="Fee Frequency Status"
      value={searchFilterText}
      onChange={(e) => setSearchFilterText(e.target.value)}
      style={{
        width: '100%',
        height: '34px',
        padding: '4px 6px 4px 30px',
        border: '1px solid #c6c9c9ff',
        borderRadius: '6px',
        fontSize: '14px',
        outline: 'none',
      }}
    />
  </div>

  <button
    onClick={handleClearFilter}
    style={{
      height: '38px',
      backgroundColor: '#53b7e8',
      border: 'none',
      color: '#fff',
      padding: '0 18px',
      borderRadius: '6px',
      cursor: 'pointer',
      fontWeight: '500',
    }}
  >
    Clear
  </button>
</div>


<div
  className="atm-column-header-grid"
  style={{
    marginTop: '-12px',
    height: '65px',
    maxWidth: '1299px',
    display: 'flex',
    justifyContent: 'space-between',
    backgroundColor: 'white',
    padding: '14px 24px',
    borderRadius: '10px',
    fontWeight: '600',
    fontSize: '16px',
    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
    marginBottom: '12px',
    color: '#444',
    textAlign: 'center',
  }}
>
  <div style={{ width: '80px', textAlign: 'center' }}>
    Sr.No
  </div>

  <div style={{ flex: 1, textAlign: 'center' }}>
    Account Type Name
  </div>

  <div style={{ width: '120px', textAlign: 'center' }}>
    Actions
  </div>
</div>


      <div className="atm-records-area" style={{textAlign:'center'}}>
{filteredEntries.map((entry, index) => (
  <div
    key={entry.identifier}
    className="atm-record-item"
    style={{
      height: '45px',
      maxWidth: '1299px',
      display: 'flex',
      alignItems: 'center',
      padding: '14px 24px',
      backgroundColor: 'white',
      borderRadius: '10px',
      boxShadow: '0 2px 8px rgba(0,0,0,0.05)',
      marginBottom: '12px',
      fontWeight: '500',
      fontSize: '15px',
      color: '#222',
      textAlign: 'center',
    }}
  >
 
    <div style={{ width: '80px', textAlign: 'center' }}>
      {index + 1}
    </div>

    <div style={{ flex: 1, textAlign: 'center' }}>
      {entry.accountTypeName}
    </div>

    <div
      style={{
        color:'#838181ff',
        width: '120px',
        display: 'flex',
        justifyContent: 'center',
        gap: '2px',           
      }}
    >
      <button
  onClick={() => handleInitiateEdit(entry)}
  style={{
    backgroundColor: 'transparent',
    border: 'none',
    cursor: 'pointer',
    padding: '4px',
  }}
>
  <Pencil size={18} color="#525151ff" />
</button>

<button
  onClick={() => handlePerformDelete(entry.identifier)}
  style={{
    backgroundColor: 'transparent',
    border: 'none',
    cursor: 'pointer',
    padding: '4px',
  }}
>
  <Trash2 size={18} color="#525151ff" />
</button>

    </div>
  </div>
))}

      </div>

      <div className="atm-bottom-info" style={{ maxWidth: '700px', paddingLeft: '24px', color: '#424141ff', fontSize: '14px' }}>
        Showing 1-{filteredEntries.length} of {filteredEntries.length} items.
      </div>

      <Modal show={dialogOpen} onHide={() => setDialogOpen(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>{editingEntry ? 'Edit Account Type' : 'Create Account Type'}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-3">
              <Form.Label>Account Type Name</Form.Label>
              <Form.Control
                type="text"
                value={nameFieldValue}
                onChange={(e) => setNameFieldValue(e.target.value)}
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setDialogOpen(false)}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleConfirmSave}>
            Save
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}
